import {cloneElement, ReactElement, useCallback} from 'react';
import {useThirdPartyAddressSearch} from '@/api/address3party';
import {PostcodeData} from '@/interface';

interface IProps {
  render: ReactElement<any>;
  onComplete?(data: PostcodeData): void;
}

export const PostcodeFinder: React.FC<IProps> = ({render, onComplete}) => {
  const thirdPartyAddrSearch = useThirdPartyAddressSearch();

  const handleOpen = useCallback(() => {
    new daum.Postcode({
      oncomplete: (rawdata) => {
        const data: PostcodeData = {...rawdata};

        thirdPartyAddrSearch(data.address, 1)
          .then((result) => {
            if (result?.length) {
              const [item] = result;

              data.coordinates = [Number(item.y), Number(item.x)];
              data.city = (
                item?.address || item?.road_address
              )?.region_1depth_name;
              data.geocodeResult = item;

              onComplete?.(data);
            } else {
              throw new Error('주소 검색 실패');
            }
          })
          .catch((e) => {
            console.error(e);
          });
      },
    }).open();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onComplete]);

  return cloneElement(render, {
    onClick: handleOpen,
  });
};
